<script lang="ts" setup>
const props = defineProps<{
  productId: string
}>()

const { t } = useI18n()
const prizeMoney = usePrizeMoney()
const { soldCount, repeatPurchaseCount, currentlyViewingCount } = useProductMetrics(props.productId)

const addTextContext = (text: string) => text.replace(/(\*\*)(.*?)(\*\*)/g, '<span>$2</span>')
</script>

<template>
  <section>
    <div class="mb-4 flex flex-col gap-y-1">
      <div class="flex items-center">
        <div class="flex items-center rounded bg-success/10 px-2 py-1">
          <Icon name="lucide:truck" class="text-lg text-success" />
          <p class="ml2 text-sm text-success fw600">
            {{ t('product.fastest_delivery') }}: {{ t('delivery.within_n_working_days', 4).toUpperCase() }}
          </p>
        </div>
      </div>

      <div class="flex items-center">
        <Icon name="lucide:eye" class="text-lg text-orange5" />
        <p
          class="ml2 text-sm text-muted-foreground [&_span]:text-orange5 [&_span]:fw600"
          v-html="addTextContext(t('product.currently_viewing_n_customers', [currentlyViewingCount]))"
        />
      </div>

      <div class="flex items-center">
        <Icon name="lucide:trophy" class="text-lg text-orange5" />
        <p
          class="ml2 text-sm text-muted-foreground [&_span]:text-orange5 [&_span]:fw600"
          v-html="addTextContext(t('promotion.purchase_competition_prizes', [`**${prizeMoney}**`]))"
        />
      </div>

      <div class="flex items-center">
        <Icon class="text-lg text-red4" name="lucide:flame" />
        <p
          class="ml2 whitespace-nowrap text-sm text-muted-foreground [&>span]:text-red4 [&>span]:fw600"
          v-html="addTextContext(t('product.hot_item_sold_count', [soldCount]))"
        />
      </div>

      <div class="flex items-center">
        <Icon class="text-lg text-blue5" name="lucide:thumbs-up" />
        <p
          class="ml2 whitespace-nowrap text-sm text-muted-foreground [&>span]:text-blue5 [&>span]:fw600"
          v-html="addTextContext(t('product.customers_repeat_purchases', [repeatPurchaseCount]))"
        />
      </div>
    </div>

    <!--    <div -->
    <!--      class="flex items-center justify-center gap-2 rounded-md bg-orange-100 px-3 py-2 text-sm text-orange-700 font-medium" -->
    <!--    > -->
    <!--      <span> -->
    <!--        <Icon name="lucide:hourglass" /> -->
    <!--        Sleva končí za:</span> -->
    <!--      <span id="countdown" class="font-bold tabular-nums">09:59</span> -->
    <!--    </div> -->
  </section>
</template>
